import { gql } from '@apollo/client';

export const ALL_ACTIVITIES_ASSIGNED_USERS = gql`
  query AllActivitiesAssignedUsers($input: ActivitiesAssignedUsersInput!) {
    users: allActivitiesAssignedUsers(input: $input) {
      id
      firstName
      lastName
    }
  }
`;
